// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { getObjectKeys, NullPartial, omitKeys, pickKeys, subsetTypeHasKey, ValueOf } from "@hex-insights/core";
import {
	StudentMedicationNoteCreateInput,
	StudentMedicationNoteDetailQuery,
	StudentMedicationNoteInStudentNoteCreateInput,
	StudentMedicationNoteUpdateInput,
} from "../../../Utilities";
import * as StudentMedicationNoteFormValues from "./form-values";

/**
 * Converts the given `formValues` for the create form to a GraphQL create input for the StudentMedicationNote model.
 *
 * @param formValues The form values to convert.
 */
export function toGQLCreateInput<
	K extends keyof StudentMedicationNoteFormValues.Create = keyof StudentMedicationNoteFormValues.Create,
>(formValues: StudentMedicationNoteFormValues.CreateSubset<K>): StudentMedicationNoteCreateInput {
	const input: NullPartial<StudentMedicationNoteCreateInput> = { ...formValues };
	return input as StudentMedicationNoteCreateInput;
}

/**
 * Converts the given `formValues` for the create form nested in the StudentNote to a GraphQL nested create input for the StudentMedicationNote model.
 *
 * @param formValues The form values to convert.
 */
export function toGQLCreateInStudentNoteInput<
	K extends keyof StudentMedicationNoteFormValues.CreateInStudentNote = keyof StudentMedicationNoteFormValues.CreateInStudentNote,
>(
	formValues: StudentMedicationNoteFormValues.CreateInStudentNoteSubset<K>,
): StudentMedicationNoteInStudentNoteCreateInput {
	const input: NullPartial<StudentMedicationNoteInStudentNoteCreateInput> = { ...formValues };
	return input as StudentMedicationNoteInStudentNoteCreateInput;
}

/**
 * Converts the given `formValues` for the detail form to a GraphQL update input for the StudentMedicationNote model.
 *
 * @param formValues The form values to convert. Generally only the changed form values.
 * @param initialFormValues The initial values of the form.
 */
export function toGQLUpdateInput<
	K extends keyof StudentMedicationNoteFormValues.Detail = keyof StudentMedicationNoteFormValues.Detail,
>(
	formValues: Partial<StudentMedicationNoteFormValues.DetailSubset<K>>,
	_initialFormValues?: StudentMedicationNoteFormValues.DetailSubset<K>,
): StudentMedicationNoteUpdateInput {
	const inputFormValues = omitKeys(formValues, ["studentNoteID"]);
	const input: StudentMedicationNoteUpdateInput = { ...inputFormValues };
	return input;
}

export type StudentMedicationNoteFormKeyMap = {
	body: "body";
	studentNoteID: "studentNote";
};

export type ToFormValuesArgs<
	K extends keyof StudentMedicationNoteFormValues.Detail = keyof StudentMedicationNoteFormValues.Detail,
> = {
	studentMedicationNote: Pick<
		StudentMedicationNoteDetailQuery["studentMedicationNote"],
		ValueOf<Pick<StudentMedicationNoteFormKeyMap, K>>
	>;
	fields?: { [Key in K]: true };
};

/**
 * Converts a StudentMedicationNote instance to its corresponding detail form values.
 *
 * @param studentMedicationNote The instance to convert.
 * @param fields The subset of fields to include.
 */
export function toFormValues<
	K extends keyof StudentMedicationNoteFormValues.Detail = keyof StudentMedicationNoteFormValues.Detail,
>({ studentMedicationNote, fields }: ToFormValuesArgs<K>): StudentMedicationNoteFormValues.DetailSubset<K> {
	const formValues = {
		body: subsetTypeHasKey(studentMedicationNote, "body") ? studentMedicationNote.body : "",
		studentNoteID: subsetTypeHasKey(studentMedicationNote, "studentNote")
			? studentMedicationNote.studentNote?.id ?? null
			: null,
	};
	return fields ? pickKeys(formValues, getObjectKeys(fields)) : formValues;
}
